module.exports = __webpack_public_path__ + "img/3.1b5e1556.png";